module.exports = __webpack_public_path__ + "img/samolot.c820ebb6.png";